// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateCouponWholeOrderType_wrapper__rZBBf","blockTitle":"CreateCouponWholeOrderType_blockTitle__j1DMb","smallPadding":"CreateCouponWholeOrderType_smallPadding__ggbqQ"};